<!--
  Trading-mode pill — GAP-004 + GAP-FE-B011 (glyph variant) + GAP-005 (tri-state).
  PAPER mode:   amber, warning-style (system in sandbox), ▲ glyph.
  LIVE mode:    red, pulsing dot (real money on the line), ■ glyph.
  UNKNOWN mode: neutral grey, ○ glyph (no trustworthy reading yet — startup
                or a persistent health outage). We never render a definitive
                LIVE/PAPER pill we cannot vouch for; see TradingModeService.
  When the last poll failed but a prior reading is retained, `--stale` dims the
  pill to flag the value as unverified. The visible text is driven by the same
  tri-state as the aria-label, so sighted and screen-reader output never diverge.
  The colour-blind-safe glyph keeps the trading-mode signal legible without colour.
-->
<span class="bb-status bb-status--shape"
      [class.bb-status--warning]="mode() === 'paper'"
      [class.bb-status--live]="mode() === 'live'"
      [class.bb-status--neutral]="mode() === 'unknown'"
      [class.bb-status--stale]="isStale() && isModeKnown()"
      role="status"
      [attr.aria-label]="statusText()
        + (isStale() ? ' (unverified)' : '')
        + (lastChecked() ? ' updated ' + (lastChecked() | date:'short') : '')">
  <span class="gly" aria-hidden="true">{{ modeGlyph() }}</span>
  {{ statusGlyphText() }}
  @if (!compact()) {
    <span class="bb-status__env">· {{ envLabel() }}</span>
  }
</span>
